import { Helmet } from "react-helmet"
import { getProductVIPUrl } from "../../utils"
import { t } from "@lingui/macro"
import { useLocation } from "react-router-dom"
import { useMeta } from "./hooks/useMeta"
import { useProductsStore } from "./provider/ProductStoreProvider"
import { useStoreState } from "../../providers/StoreProvider"

export function ProductListHead() {
  const { categories } = useMeta()
  const { products } = useProductsStore()

  const canonicalHref = window.location.href.split("?")[0]

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const searchValue = searchParams.get("search")

  const categoriesNames = categories.length
    ? categories[categories.length - 1].name
    : ""

  let titleInfo
  let descriptionInfo
  const ogImage = useStoreState()[0].config.logoHeader.img
  const imageLogoParsed = ogImage ? JSON.parse(ogImage) : undefined
  const logoType = useStoreState()[0].config.logoHeader?.type
  const ogImageUrl =
    logoType === "I" && imageLogoParsed ? imageLogoParsed.small : undefined

  if (searchValue !== null) {
    titleInfo = `${searchValue} - ${window.STORE_NAME}`
    descriptionInfo = t`Encontrá ${searchValue} en ${window.STORE_NAME}. Comprá online con envío y múltiples medios de pago.`
  } else {
    if (categories.length) {
      titleInfo = t`Comprar ${categoriesNames} en ${window.STORE_NAME}`
      descriptionInfo = t`Encontrá los mejores ${categoriesNames} en ${window.STORE_NAME}. Variedad de productos, envíos y múltiples medios de pago.`
    } else {
      titleInfo = t`Comprá online productos en ${window.STORE_NAME}`
      descriptionInfo = t`Encontrá todo lo que buscás en ${window.STORE_NAME}. Comprá online con envío y múltiples medios de pago.`
    }
  }

  const breadcrumbSchema =
    categories.length > 0
      ? {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: categories.map((cat, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: cat.name,
            item: `${window.location.origin}${cat.url}`,
          })),
        }
      : null

  const itemListSchema =
    products.length > 0
      ? {
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: categoriesNames || window.STORE_NAME,
          itemListElement: products.slice(0, 20).map((product, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: product.title,
            url: `${window.location.origin}/${getProductVIPUrl(
              product.title
            )}-rtid${product.identifier}/`,
          })),
        }
      : null

  return (
    <Helmet>
      <title>{titleInfo}</title>
      <link rel="canonical" href={canonicalHref} />
      <meta name="description" content={descriptionInfo} />

      <meta property="og:site_name" content={window.STORE_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={titleInfo} />
      <meta property="og:description" content={descriptionInfo} />
      <meta property="og:url" content={canonicalHref} />
      {ogImageUrl && <meta property="og:image" content={ogImageUrl} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={titleInfo} />
      <meta name="twitter:description" content={descriptionInfo} />
      {ogImageUrl && <meta name="twitter:image" content={ogImageUrl} />}

      {breadcrumbSchema && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      )}
      {itemListSchema && (
        <script type="application/ld+json">
          {JSON.stringify(itemListSchema)}
        </script>
      )}
    </Helmet>
  )
}
